import {useEffect, useRef} from 'react';
import {
  Conversation,
  BaseConversationMessage,
} from '@stripe-internal/conversations-client';

export function getQueryForMessage(
  conversation: Conversation,
  message: BaseConversationMessage,
) {
  const logItems = conversation.log.get();

  let idx = logItems.findIndex((m) => m.id === message.id) - 1;
  while (idx > 0) {
    const item = logItems[idx];

    if (
      item.name === 'conversation-message-added' &&
      item.message.type === 'text-conversation-message' &&
      item.message.participant.role === 'user'
    ) {
      return item.message.text;
    }

    // eslint-disable-next-line no-plusplus
    idx--;
  }

  return null;
}

export function isAssistantEntryPoint(conversation: Conversation) {
  return conversation.context.triggerParams?.triggerPoint?.startsWith(
    'assistant',
  );
}

export function useAssistantAnalyticsCall(
  conversation: Conversation,
  message: BaseConversationMessage,
  func: (query: string | null) => void,
) {
  const hasCalled = useRef(false);

  useEffect(() => {
    // We REALLY only ever record a single analytics call once. We
    // pass a bunch of things on the deps array, but we track if this
    // has ever been called to ensure we never log it twice
    if (!hasCalled.current) {
      if (isAssistantEntryPoint(conversation)) {
        func(getQueryForMessage(conversation, message));
      }
      hasCalled.current = true;
    }
  }, [conversation, message, func]);
}
